import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { api, money } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function Account() {
  const { user, loading } = useAuth();
  const navigate = useNavigate();
  const [orders, setOrders] = useState([]);
  const [fetched, setFetched] = useState(false);

  useEffect(() => {
    if (loading) return;
    if (!user) { navigate("/"); return; }
    api.get("/orders").then(({ data }) => { setOrders(data); setFetched(true); }).catch(() => setFetched(true));
  }, [user, loading, navigate]);

  if (loading || !user) return <div className="min-h-screen bg-[#050505]" />;

  return (
    <div className="min-h-screen bg-[#050505] px-6 pb-32 pt-32 md:px-12 md:pt-40" data-testid="account-page">
      <div className="mx-auto max-w-[1600px]">
        <motion.div initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.9 }}>
          <p className="text-[11px] uppercase tracking-[0.4em] text-gold">Private client</p>
          <h1 className="font-serif-lux mt-4 text-5xl font-light leading-none text-[#f5f5f0] md:text-7xl">
            {user.name || "Your collection"}
          </h1>
          <p className="mt-4 text-sm font-light text-[#a1a1aa]">{user.email}</p>
        </motion.div>

        <div className="mt-20">
          <h2 className="font-serif-lux mb-8 text-3xl font-light text-[#f5f5f0]">Acquired pieces</h2>
          {!fetched ? (
            <p className="text-sm font-light text-[#52525b]">Loading…</p>
          ) : orders.length === 0 ? (
            <div className="border border-white/10 p-14 text-center" data-testid="orders-empty">
              <p className="font-serif-lux text-3xl font-light italic text-[#52525b]">Your collection is waiting.</p>
              <Link to="/marketplace" className="mt-8 inline-block rounded-none border border-[#f5f5f0] px-8 py-4 text-[11px] uppercase tracking-[0.3em] text-[#f5f5f0] hover:bg-[#f5f5f0] hover:text-black">
                Explore the collection
              </Link>
            </div>
          ) : (
            <div className="divide-y divide-white/10 border-y border-white/10">
              {orders.map((o) => (
                <div key={o.session_id} data-testid="order-row" className="flex items-center justify-between py-6">
                  <div>
                    <p className="font-serif-lux text-2xl font-light text-[#f5f5f0]">{o.product_title}</p>
                    <p className="mt-1 text-[10px] uppercase tracking-[0.25em] text-gold">Acquired · 1 of 1</p>
                  </div>
                  <p className="text-sm font-light text-[#a1a1aa]">{money(o.amount || 0, o.currency || "usd")}</p>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
